export default {
  rowLabel: "custom field {{name}}",
  customFields: "Custom Fields",
  code: "Code",
  name: "Name",
  type: "Type",
  required: "Required",
  order: "Order",
  valuesCount: "Values Count",
  options: "Options",
  customFieldType: {
    text: "Text",
    number: "Number",
    date: "Date",
    select: "Select",
    checkbox: "Checkbox",
  },
  customizableType: {
    clients: "Clients",
    invoices: "Invoices",
    projects: "Projects",
  },
  confirmDeleteTitle: "Delete Custom Field",
  confirmDeleteMessage: "Are you sure you want to delete this custom field?",
  addOption: "Add Option",
  optionsInfo: "Options are only applicable for select type custom fields.",
  optionPlaceholder: "Enter option value",
  typeNumber: "Number",
  typeText: "Text",
  typeDate: "Date",
  typeSelect: "Select",
  typeCheckbox: "Checkbox",
  createdAt: "Created At",
  usedIn: "Used In",
  backToList: "Back to custom fields list",
  editCustomField: "Edit {{name}}",
  saveCustomField: "Save Custom Field",
  createCustomField: "Create Custom Field",
  requiredInfo: "Selecting this options will make this field mandatory.",
  customizables: "Customizables",
  customizableInfo: "This field can be used in the following resources.",
  customizablesPlaceholder: "Select customizables",
  customFieldDeleted: "Custom field(s) deleted successfully.",
  customFieldNotFound: "Custom field not found.",
  customFieldUpdated: "Custom field updated successfully.",
};
